import React from 'react';
import { AboutSection } from '../components/AboutSection';
import { PolaGroupSection } from '../components/PolaGroupSection';
import { SolutionsSection } from '../components/SolutionsSection';
export function AboutPage() {
  return <div className="pt-28" data-id="element-598">
      <AboutSection data-id="element-599" />
      <PolaGroupSection data-id="element-600" />
      <SolutionsSection data-id="element-601" />
    </div>;
}